import { Label } from '@headlessui/react/dist/components/label/label';
import ReactGA from 'react-ga';
import { solution, solutionIndex } from './words';

export const sendGameFinishedEvent = () => {
    ReactGA.event({
        category: "GAME",
        action: `Game finished`
    })
}

export const sendGameWonEvent = (guesses: number) => {
    ReactGA.event({
        category: "GAME",
        action: `Game #${solutionIndex}`,
        label: `${guesses + 1} / 7`,
    })
}


export const sendGameLostEvent = () => {
    ReactGA.event({
        category: "GAME",
        action: `Game #${solutionIndex}`,
        label: `X / 7`
    })
}

export const sendSpotifyEvent = () => {
    ReactGA.event({
        category: "GAME",
        action: `${solutionIndex} streaming`,
        label: `Spotify`
    })
}

export const sendSoundcloudEvent = () => {
    ReactGA.event({
        category: "GAME",
        action: `${solution} streaming`,
        label: `Soundcloud`
    })
}


export const pageViews = () => {
    ReactGA.pageview("/")
}